import placeholders from "@pub/placeholders";
import { ResponsiveImage, SupportedCrops } from "@sphtech/dmg-design-system";
import { getGeniusLink } from "@src/app/utils/trackers/skimlinks";
import { Disclaimer } from "packages/design-system/src/components/Element/Typography";

import {
  isCUEImageElement,
  ResolvedColumnImageElement,
  ResolvedCUEElement,
  resolveImageCrop,
} from "../elements";
import styles from "../Storyline.module.css";

const isResolvedColumnInfo = (
  item?: ResolvedCUEElement,
): item is ResolvedColumnImageElement =>
  !!item && item.type === "column_images_item_info";

export function ColumnImage({
  element: { children },
  bodyMaxWidth,
  imageCrop = "portrait",
}: {
  element: ResolvedCUEElement;
  bodyMaxWidth: number;
  imageCrop?: SupportedCrops;
}) {
  return (
    <div className={styles.columnImageContainer}>
      {children?.map((item, index) => {
        if (!item.children) return;
        const image = item.children.find((item) => item.type === "image");
        const crop =
          isCUEImageElement(image) && resolveImageCrop(image, imageCrop);
        if (!crop) {
          return null;
        }

        const imageElement = (
          <ResponsiveImage
            key={index}
            src={crop.src}
            alt={crop.alt}
            srcWidth={crop.srcWidth}
            srcHeight={crop.srcHeight}
            displayWidth={bodyMaxWidth / 2}
            loading="lazy"
            errorSrc={placeholders.portrait.src}
          />
        );

        const link = item.children.find(
          (item) => item.type === "column_images_item_info",
        );
        const href =
          isResolvedColumnInfo(link) && link.additionalFields.targetUrl?.value;

        const title = isResolvedColumnInfo(link) &&
          link.additionalFields.title?.value && (
            <Disclaimer>{link.additionalFields.title.value}</Disclaimer>
          );

        if (href) {
          return (
            <a
              key={index}
              className={styles.column}
              href={getGeniusLink(href)}
              target="_blank"
              rel="noreferrer"
            >
              {imageElement}
              {title}
            </a>
          );
        }

        return (
          <div key={index} className={styles.column}>
            {imageElement}
            {title}
          </div>
        );
      })}
    </div>
  );
}
